const commonWorkSheetFields = [
    { name: 'workplace', value: true, width: 250 },
    { name: 'position', value: true, width: 250 },
    { name: 'documents', value: true, width: 230 },
    { name: 'partsInProject', value: true, width: 200 },
    { name: 'comment', value: true, width: 300 },
    { name: 'education', value: true, width: 450 }
];

export const defaultProjectListSettings = {
    $name: 'tables.project',
    $path: ['tables', 'project'],
    stringHeight: '3',
    locked: 0,
    fields: [
        { name: 'posname', value: true, width: 300, hideable: false, keySort: 'position' },
        { name: 'numeqpos', value: true, keyName: 'quantity' },
        { name: 'town', value: false, width: 150, keySort: 'townName' },
        { name: 'company', value: true, width: 150, keySort: 'companyName' },
        { name: 'status', value: true, width: 175, hideable: false },
        { name: 'closebefore', value: true, keySort: 'dateFrom', version: ['KA', 'HR'] },
        { name: 'duration', value: true },
        { name: 'emplofra', value: false, width: 250, version: ['KA', 'HR'] },
        { name: 'clientcontactpers', value: false, width: 250, version: ['ANCOR'] },
        { name: 'icustomer', value: false, keyName: 'innerCustomer', version: ['KA', 'HR'] },
        { name: 'prjtype', value: false, keyName: 'projectType', version: ['KA', 'HR'] },
        { name: 'feetype', value: true, version: ['KA', 'HR'] },
        { name: 'feepercent', value: true, version: ['KA', 'HR'] },
        { name: 'feeperpos', value: true },
        { name: 'feecurrency', value: true },
        { name: 'transprice', value: true, version: ['ANCOR'] },
        { name: 'feecomments', value: false, version: ['ANCOR'] },
        { name: 'responsible', value: true, width: 150, keySort: 'responsibleName' },
        { name: 'cforesps', value: false, version: ['ANCOR'] },
        { name: 'salary', value: true },
        { name: 'requirements', value: true, width: 200 },
        { name: 'workresps', value: true, width: 200, keyName: 'responsibilities' },
        { name: 'conditions', value: false, version: ['KA', 'HR'] },
        { name: 'probation', value: false },
        { name: 'negwithclient', value: false },
        { name: 'ParticipantsWithRole', version: ['ANCOR'], value: false, width: 350, keyName: 'coexecutors' },
        { name: 'candidates', width: 300, value: true },
        { name: 'workcommit', width: 300, value: true, version: ['ANCOR'] },
        { name: 'execdate', value: false, version: ['ANCOR'] },
        { name: 'result', value: true, width: 300 },
        { name: 'participants', value: true, width: 400, version: ['KA', 'HR'] },
        { name: 'approval', value: false, width: 300, version: ['KA', 'HR'] },
        { name: 'prjstart', value: false, version: ['ANCOR'] },
        { name: 'lastchgdate', value: false, version: ['ANCOR'] },
        { name: 'category', value: false, version: ['ANCOR'] },
        { name: 'classifier', value: false, width: 300, version: ['ANCOR'], keyName: 'classifiers'},
        { name: 'foreignlngs', value: false, width: 250, keyName: 'foreignLanguage' },
        { name: 'sex', value: false, version: ['KA', 'HR'] },
        { name: 'age', value: false, version: ['KA', 'HR'] },
        { name: 'compdepart', value: false, keyName: 'companyDepartment' },
        { name: 'posdepart', value: false, keyName: 'departmentPosition' },
        { name: 'amountmin', value: false, keyName: 'amountMin' },
        { name: 'amountmax', value: false, keyName: 'amountMax' },
        { name: 'amount', value: false, version: ['KA', 'HR'] },
        { name: 'bonuses', value: false, width: 200 },
        { name: 'education', value: false, width: 200 },
        { name: 'personalqual', value: false, width: 200, keyName: 'personalQualities' },
        { name: 'experience', value: false, width: 600, version: ['KA', 'HR'] },
        { name: 'icustomer', value: false, keyName: 'innerCustomer', version: ['KA', 'HR'] },
        { name: 'comments', value: false, width: 200, version: ['KA', 'HR'] },
    ],
};

export const defaultProjectMassListSettings = {
    $name: 'tables.project',
    $path: ['tables', 'project'],
    stringHeight: '3',
    locked: 0,
    fields: [
        { name: 'posname', value: true, width: 300, hideable: false, keySort: 'position' },
        { name: 'company', value: true, width: 150, keySort: 'companyName' },
        { name: 'status', value: true, width: 175, hideable: false },
        { name: 'numeqpos', value: true, keyName: 'quantity' },
        { name: 'inworkdate', value: true },
        { name: 'closebefore', value: true, keySort: 'dateFrom', version: ['KA', 'HR'] },
        { name: 'duration', value: true },
        { name: 'responsible', value: true, width: 150, keySort: 'responsibleName' },
        { name: 'participants', value: true, width: 400, version: ['KA', 'HR'], hideable: false },
        { name: 'requirements', value: true, width: 200 },
        { name: 'workresps', value: true, width: 200, keyName: 'responsibilities' },
        { name: 'feeperpos', value: true },
        { name: 'feepercent', value: true, version: ['KA', 'HR'] },
        { name: 'feetype', value: true, version: ['KA', 'HR'] },
        { name: 'feecurrency', value: true },
        { name: 'scenname', value: false, width: 200, keyName: 'scenarioName' },
        { name: 'town', value: false, width: 150, keySort: 'townName' },
        { name: 'education', value: false, width: 200 },
        { name: 'foreignlngs', value: false, width: 250, keyName: 'foreignLanguage' },
        { name: 'amountmin', value: false, keyName: 'amountMin' },
        { name: 'amountmax', value: false, keyName: 'amountMax' },
        { name: 'bonuses', value: false, width: 200 },
        { name: 'experience', value: false, width: 600, version: ['KA', 'HR'] },
        { name: 'amount', value: false, version: ['KA', 'HR'] },
        { name: 'comments', value: true, width: 200, version: ['KA', 'HR'] },
        { name: 'compdepart', value: false, keyName: 'companyDepartment' },
        { name: 'posdepart', value: false, keyName: 'departmentPosition' },
        { name: 'sex', value: false, version: ['KA', 'HR'] },
        { name: 'age', value: false, version: ['KA', 'HR'] },
        { name: 'personalqual', value: false, width: 200, keyName: 'personalQualities' },
        { name: 'approval', value: false, width: 300, version: ['KA', 'HR'] },
        { name: 'icustomer', value: false, keyName: 'innerCustomer', version: ['KA', 'HR'] },
    ],
};

export const defaultWorksheetListSettings = {
    $name: 'tables.project_worksheet',
    $path: ['tables', 'project_worksheet'],
    stringHeight: '3',
    locked: 0,
    fields: [
        { name: 'text', value: true, width: 200, hideable: false, keySort: 'peopleName' },
        { name: 'status', value: true, width: 300 },
        { name: 'additionalStatus', value: true, width: 220 },
        { name: 'contacts', value: true, width: 200 },
        { name: 'working', value: true, width: 500 },
        { name: 'sourceForSys', value: true, width: 200 },
        { name: 'sourceForProject', value: true, width: 200 },
        ...commonWorkSheetFields,
    ]
};

export const defaultWorksheetMassListSettings = {
    $name: 'tables.project_worksheet',
    $path: ['tables', 'project_worksheet'],
    stringHeight: '3',
    locked: 0,
    fields: [
        { name: 'text', value: true, width: 200, hideable: false, keySort: 'peopleName' },
        { name: 'contacts', value: true, width: 200 },
        { name: 'working', value: true, width: 500 },
        { name: 'sourceforsys', value: true, width: 200 },
        { name: 'sourceforprj', value: true, width: 200 },
        { name: 'stageresult', value: true, width: 300 },
        { name: 'prevStageResults', value: true, width: 300 },
        ...commonWorkSheetFields
    ]
};
